<template>
  <div id="app">
    Politica
    {{ this.$route.path }}
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
